import type { UseMutationOptions, UseMutationResult } from "@tanstack/react-query";
import { useMutation } from "@tanstack/react-query";
import client from "@/api/client/axios";
import type { ResponseConfig } from "@/api/client/axios";
import type { CheckPhoneV2MutationRequest, CheckPhoneV2MutationResponse, CheckPhoneV2500 } from "../types/CheckPhoneV2";

/**
 * @summary Проверка телефона
 * @link /api/v2/auth/check/phone
 */

export function useCheckPhoneV2 <TData = CheckPhoneV2MutationResponse, TError = CheckPhoneV2500, TVariables = CheckPhoneV2MutationRequest>(options: {
          mutation?: UseMutationOptions<ResponseConfig<TData>, TError, TVariables>,
          client?: Partial<Parameters<typeof client<TData, TError, TVariables>>[0]>,
      } = {}): UseMutationResult<ResponseConfig<TData>, TError, TVariables> {
  const { mutation: mutationOptions, client: clientOptions = {} } = options ?? {};

  return useMutation<ResponseConfig<TData>, TError, TVariables>({
    mutationFn: (data) => {
      
      return client<TData, TError, TVariables>({
        method: "post",
        url: `/api/v2/auth/check/phone`,
        data,
        
        
        ...clientOptions
      });
    },
    ...mutationOptions
  });
};
